// extracted by mini-css-extract-plugin
module.exports = {"trigger":"WorldHelp_trigger__ViEeg","legend":"WorldHelp_legend__xuss0","item":"WorldHelp_item__O4qqd","icon":"WorldHelp_icon__ZjATZ"};